{
  "version": 1,
  "asset_id": "5a2b3ca2-ddb1-4d79-a041-037cc506ba14",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/5a2b3ca2-ddb1-4d79-a041-037cc506ba14/silivri-hizli-elektrikci-7-24-dukkan-5.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/5a2b3ca2-ddb1-4d79-a041-037cc506ba14/silivri-hizli-elektrikci-7-24-dukkan-5.jpg",
  "original_filename": "silivri-hizli-elektrikci-7-24-dukkan-5.jpg",
  "size": 147344,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:26:48Z"
}
